(function(){
  function scrollPopupToTop(){
    var popover = document.querySelector('.jdgm-popover');
    if(!popover) return;

    // Remove overflow hidden from body
    document.body.style.removeProperty('overflow');
    document.documentElement.style.removeProperty('overflow');

    // Make popover scrollable with touch
    popover.style.setProperty('overflow-y', 'scroll', 'important');
    popover.style.setProperty('-webkit-overflow-scrolling', 'touch', 'important');
    popover.style.setProperty('touch-action', 'pan-y', 'important');

    // SCROLL TO TOP so stars are visible
    popover.scrollTop = 0;
    popover.scrollTo(0, 0);
    window.scrollTo(0, 0);
  }

  // Watch for popup opening
  new MutationObserver(function(mutations){
    mutations.forEach(function(m){
      m.addedNodes.forEach(function(node){
        if(node.nodeType !== 1) return;
        if(node.classList && node.classList.contains('jdgm-popover')){
          setTimeout(scrollPopupToTop, 100);
          setTimeout(scrollPopupToTop, 400);
        }
      });
      if(m.type === 'attributes' && m.target === document.body){
        var pop = document.querySelector('.jdgm-popover');
        if(pop) setTimeout(scrollPopupToTop, 100);
      }
    });
  }).observe(document.body, {childList:true, subtree:true, attributes:true, attributeFilter:['style','class']});

  // Also fire on click
  document.addEventListener('click', function(e){
    if(!e.target.closest('.jdgm-write-rev-link, .jdgm-write-rev-btn')) return;
    setTimeout(scrollPopupToTop, 200);
    setTimeout(scrollPopupToTop, 500);
    setTimeout(scrollPopupToTop, 1000);
  });
})();